/**
 * LocationFormSheet.js — WhatsApp location-message sheet (#121).
 *
 * Pure presentational component extracted from Composer.js so that file
 * can stay under a reasonable size. State lives in the parent Composer
 * and is passed down via props. Submit + geolocation callbacks also
 * live in the parent.
 */

import { html } from 'htm/preact';

export function LocationFormSheet({ form, setForm, onClose, onSubmit, onFillCurrent }) {
  if (!form) return null;

  return html`
    <div class="inbox-sheet-overlay" style="display:block" onClick=${onClose}></div>
    <div
      class="inbox-bottom-sheet"
      style="display:flex;flex-direction:column;max-height:80vh;background:var(--v2-bg-elevated, #131722)"
      role="dialog"
      aria-modal="true"
      aria-label="Send location"
      onClick=${(e) => e.stopPropagation()}
    >
      <div class="inbox-sheet-handle"></div>
      <div class="inbox-sheet-header">
        <h3 class="inbox-sheet-title">📍 Send location</h3>
        <button class="inbox-sheet-close" onClick=${onClose}>×</button>
      </div>
      <div style="padding:12px 14px 16px;overflow-y:auto">
        <button
          onClick=${onFillCurrent}
          disabled=${form.pending}
          style="width:100%;background:rgba(37,211,102,0.12);border:1px solid rgba(37,211,102,0.35);color:#25D366;border-radius:10px;padding:10px 12px;font-size:0.85rem;font-weight:600;cursor:pointer;margin-bottom:14px;display:flex;align-items:center;justify-content:center;gap:8px"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="2" x2="12" y2="6"/>
            <line x1="12" y1="18" x2="12" y2="22"/>
            <line x1="2" y1="12" x2="6" y2="12"/>
            <line x1="18" y1="12" x2="22" y2="12"/>
          </svg>
          ${form.pending ? 'Locating…' : 'Use my current location'}
        </button>

        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px">
          <div>
            <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">Latitude</label>
            <input
              type="text" inputmode="decimal"
              value=${form.latitude}
              onInput=${(e) => setForm({ ...form, latitude: e.target.value })}
              placeholder="19.0760"
              style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem;font-family:ui-monospace,Menlo,monospace"
            />
          </div>
          <div>
            <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">Longitude</label>
            <input
              type="text" inputmode="decimal"
              value=${form.longitude}
              onInput=${(e) => setForm({ ...form, longitude: e.target.value })}
              placeholder="72.8777"
              style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem;font-family:ui-monospace,Menlo,monospace"
            />
          </div>
        </div>

        <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">Place name (optional)</label>
        <input
          type="text"
          value=${form.name}
          onInput=${(e) => setForm({ ...form, name: e.target.value })}
          placeholder="Head office"
          style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem;margin-bottom:10px"
        />

        <label style="display:block;font-size:0.7rem;color:var(--text-muted, #7d8799);margin-bottom:4px">Address (optional)</label>
        <input
          type="text"
          value=${form.address}
          onInput=${(e) => setForm({ ...form, address: e.target.value })}
          placeholder="123 Main St, Mumbai"
          style="width:100%;background:rgba(0,0,0,0.3);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:9px 10px;color:inherit;font-size:0.85rem;margin-bottom:14px"
        />

        <button
          onClick=${onSubmit}
          disabled=${form.pending}
          style="width:100%;background:#25D366;color:#0a0c12;border:none;border-radius:10px;padding:12px;font-size:0.88rem;font-weight:700;cursor:${form.pending ? 'wait' : 'pointer'};opacity:${form.pending ? 0.7 : 1}"
        >${form.pending ? 'Sending…' : 'Send location'}</button>
      </div>
    </div>
  `;
}
